import {ComputationResult} from './../computation-result';
import {Computation} from './../computation';
import {_AvailableResult} from './../available-result';

/**
 * Generated from com.dataiku.dip.eda.compute.computations.univariate.Skewness
 */
export interface Skewness extends Computation._UnivariateComputation {
    // PolyJson type
    type: 'skewness';
}

export function isSkewness(toTest: Computation): toTest is Skewness { return 'skewness' === toTest.type; }

export namespace Skewness {
    /**
     * Generated from com.dataiku.dip.eda.compute.computations.univariate.Skewness$SkewnessResult
     */
    export interface SkewnessResult extends _AvailableResult {
        value: number;

        // PolyJson type
        type: 'skewness';
    }

    export function isSkewnessResult(toTest: ComputationResult): toTest is SkewnessResult { return 'skewness' === toTest.type; }
}